const StoresDashboard: React.FC = () => {
  return <h1>Stores</h1>;
};

export { StoresDashboard };
